import { authPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_URL;

export function checkSearchList(params) {
  return authPost(`${baseUrl}/Agent2.ashx`, params);
}

export function updateMemberVip(params) {
  return authPost(`${baseUrl}/Agent2.ashx`, params);
}
